jQuery(document).ready(function($) {
    $('.mobile-featured-webinar-button:not(.mobile-featured-webinar-button), .featured-webinar-button:not(.featured-webinar-button-link), .webinar-registration-button:not(.webinar-registration-button-link)').on('click', function() {
        Swal.fire({
            title: 'Register for your free spot',
            html: '<p>' + $(this).data('disclaimer') + '</p>' + $(this).data('form-embed'),
            showConfirmButton: false,
            showCloseButton: true,
            customClass: {
                popup: 'click-to-register-popup'
            }
        });
    }); 
});